import Button from "component/Button";
import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import strings from "translate/language";

export default function PdfViewer({ pdfUrl, backButton }) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  /*To Prevent right click on screen*/
  document.addEventListener("contextmenu", (event) => {
    event.preventDefault();
  });

  /*When document gets loaded successfully*/
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }
  function onPageLoadSuccess({ pageIndex }) {
    setPageNumber(pageIndex + 1);
  }
  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  function CustomLoader() {
    return <div>Loading PDF...</div>;
  }

  const customStyle = {
    // border: '1px solid black',
    // padding: '10px',
    // margin: '10px',
    height: '500px',
  };
  return (
    <div className="page-body">
      <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col-md-8"></div>
            {/* <div className="row"> */}
            <div className="col-md-2 d-flex justify-content-end">
              <a
                href={pdfUrl}
                target="_blank"
                className="btn btn-color"

              >{strings.download}</a>
            </div>
            <div className="col-md-2 d-flex justify-content-end">
              <Button
                className="btn btn-color"
                onClick={backButton}
                label={strings.back}
              ></Button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <Document
                file={pdfUrl}
                style={customStyle}
                loading={<CustomLoader />}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                <Page pageNumber={pageNumber} renderAnnotationLayer={false} />
              </Document>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                paddingBottom: 20,
                paddingTop: 20,
              }}
            >
              <button
                type="button"
                disabled={pageNumber <= 1}
                onClick={previousPage}
                className="btn btn-color"
              >
                Previous
              </button>
              <div className="pagec">
                Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
              </div>
              <button
                type="button"
                className="btn btn-color"
                disabled={pageNumber >= numPages}
                onClick={nextPage}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
